"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var native_transforms_exports = {};
__export(native_transforms_exports, {
  renderNativeSourceModule: () => renderNativeSourceModule,
  transformTreeShakeClient: () => import_clientTreeShakePlugin.transformTreeShakeClient
});
module.exports = __toCommonJS(native_transforms_exports);
var import_clientTreeShakePlugin = require("./vite/plugins/clientTreeShakePlugin");
var import_kotlinSourceModule = require("./vite/plugins/kotlinSourceModule");
var import_swiftPackageModule = require("./vite/plugins/swiftPackageModule");
function renderNativeSourceModule(id, platform, root) {
  return id.endsWith(".kt") ? (0, import_kotlinSourceModule.renderKotlinSourceModule)(id, platform, root) : (0, import_swiftPackageModule.renderSwiftPackageModule)(id, platform, root);
}
//# sourceMappingURL=native-transforms.js.map
